import type { SupSingleVaultV3 } from "@/types";
import React, { useMemo } from "react";

import ChipVaultAssets from "@/components/Ui/Chip/Vault/Assets";
import DepositButton from "@/components/Adapter/DepositButton";

import { UiLabelChain } from "@/utils";
import { useStoredData, useStoredDataDispatch } from "@/store";
import { SupStar2 } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

interface VaultDetailsActionBarProps {
  className?: string;
  singleVault: SupSingleVaultV3;
}
export default function VaultDetailsActionBar({ className, singleVault }: VaultDetailsActionBarProps) {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();

  const isFavorite = useMemo(() => storedData.favorites.includes(singleVault.slug), [singleVault.slug, storedData.favorites]);

  const handleFavorite = () => {
    storedDispatch({ type: "toggleFavorites", vault: singleVault });
  };

  return (
    <div className={twMerge("flex flex-col items-center gap-5 md:flex-row md:gap-2 md:pr-6", className)}>
      <div className="flex items-center gap-2 text-neutral-950">
        <ChipVaultAssets assets={singleVault.assets} vaultId={singleVault.id} chain={singleVault.chain} showTooltip />
        <span className="font-mono text-base font-normal uppercase leading-none tracking-normal antialiased">ON</span>
        {UiLabelChain(singleVault.chain.id, true, true, false, "vault-details-badge border-none text-neutral-950")}
      </div>

      <div className="flex items-center gap-2">
        <button type="button" onClick={handleFavorite} className={twMerge("group relative h-10 w-10 items-center justify-center p-0")}>
          <span className="sr-only">Toggle Favorite</span>
          <SupStar2 className={twMerge("h-8 w-8 group-hover:fill-primary-500", isFavorite && "fill-primary-900")} />
        </button>
        <DepositButton arrowPlacement="bottom" singleVault={singleVault} />
      </div>
    </div>
  );
}
